import { Col, Row } from "antd";

import HexTitle from "../../HexTitle";
import { getLabel } from "../../../hooks/use-labels";
import LinkText from "../../LinkText";

const FilterHeader = ({ onClear, clearLabel }) => {
  return (
    <Row align={"middle"} className="filter-header">
      <Col lg={16} md={16} sm={16} xs={16}>
        <HexTitle title={getLabel("filtersLabel")} className="text-base-1lg" />
      </Col>

      <Col lg={8} md={8} sm={8} xs={8}>
        <LinkText
          onClick={onClear}
          text={clearLabel || getLabel("clearAll")}
          className={"clear-link-text"}
        />
      </Col>
    </Row>
  );
};

export default FilterHeader;
